<template>
  <div>
    <Navbar></Navbar>
    <NavigationProduct></NavigationProduct>
    <div class="container border shadow" style="margin-top: 20px;">
      <div class="row">
        <img
          style="width: 400px; height: 400px; margin-right: 50px;"
          :src="this.$store.state.detailProduct.image_url"
        />
        <div style="margin-top: 40px;">
          <h5 style="text-align: left; font-weight: bold;">
            Nama Barang: {{ this.$store.state.detailProduct.name }}
          </h5>
          <h5 style="text-align: left; color:#FA591D;">
            Harga: {{ price(this.$store.state.detailProduct.price) }}
          </h5>
          <h5 style="text-align: left;">
            Jumlah:
            <input v-model="quantity" style="width:50px;" type="number" />
          </h5>
          <h5 style="text-align: left;">Stock Barang: {{ stock }}</h5>
          <p style="text-align: left; color:#FA591D; margin-top: 80px;">
            Total Harga: {{ price(totalPrice) }}
          </p>

          <div style=" text-align: left;">
            <button
              type="button"
              @click="buyItem"
              class="btn border-success btn-light"
              style="color: green;"
            >
              Beli
            </button>
            <button
              @click="addToCart"
              style="margin-left: 20px;"
              type="button"
              class="btn border-light btn-success"
            >
              Tambahkan ke keranjang
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert";
import Navbar from "../components/Navbar.vue";
import NavigationProduct from "../components/NavigationProduct.vue";
export default {
  data() {
    return {
      quantity: 0
    };
  },
  methods: {
    buyItem() {
      if (!localStorage.access_token) {
        this.$router.push({ name: "Login" });
      } else {
        const quantity = this.quantity;
        if (Number(this.quantity) < 1) {
          swal("Jumlah barang yang dibeli minimal 1!", "", "error");
        } else {
          this.$store.dispatch("buyItem", {
            id: this.$route.params.id,
            quantity
          });
        }
      }
    },
    addToCart() {
      if (!localStorage.access_token) {
        this.$router.push({ name: "Login" });
      } else {
        const quantity = this.quantity;
        if (Number(this.quantity) < 1) {
          swal("Jumlah barang yang dibeli minimal 1!", "", "error");
        } else {
          this.$store.dispatch("addToCart", {
            id: this.$route.params.id,
            quantity
          });
        }
      }
    },
    price(angka) {
      var rupiah = "";
      var angkarev = angka
        .toString()
        .split("")
        .reverse()
        .join("");
      for (var i = 0; i < angkarev.length; i++)
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
      return (
        "Rp. " +
        rupiah
          .split("", rupiah.length - 1)
          .reverse()
          .join("")
      );
    }
  },
  computed: {
    totalPrice: function() {
      const price = Number(this.$store.state.detailProduct.price);
      let priceAll = price * this.quantity;
      return priceAll;
    },
    stock: function() {
      const stock = Number(this.$store.state.detailProduct.stock);
      if (stock > 5) {
        return `> 5`;
      } else {
        return stock;
      }
    }
  },
  created() {
    this.$store.dispatch("detailProduct", this.$route.params.id);
  },
  components: {
    Navbar,
    NavigationProduct
  }
};
</script>

<style></style>
